import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Label } from '../../../label';
import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './Tab.module.css';
import { Counter } from '../../../internal/components/Counter';
import { LABEL_COLORS_DEFAULT } from '../../constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Tab = function Tab(_ref) {
  var labelText = _ref.labelText,
    _ref$labelColors = _ref.labelColors,
    _ref$labelColors2 = _ref$labelColors === void 0 ? LABEL_COLORS_DEFAULT : _ref$labelColors,
    labelBackground = _ref$labelColors2.background,
    labelTextColor = _ref$labelColors2.color,
    Icon = _ref.icon,
    text = _ref.text,
    rightItem = _ref.rightItem,
    counterType = _ref.counterType,
    counter = _ref.counter,
    counterMaxLength = _ref.counterMaxLength,
    isActive = _ref.isActive,
    size = _ref.size,
    disabled = _ref.disabled,
    badged = _ref.badged,
    dataTestId = _ref.dataTestId,
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown;
  return /*#__PURE__*/_jsxs("li", {
    className: clsx(styles['tab'], _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles['tab--active'], isActive), styles['tab--small'], size === 'S'), styles['tab--medium'], size === 'M'), styles['tab--disabled'], disabled)),
    onClick: onClick,
    onKeyDown: onKeyDown,
    tabIndex: disabled ? -1 : 0,
    "data-testid": dataTestId,
    children: [labelText && /*#__PURE__*/_jsx(Label, {
      background: labelBackground,
      color: labelTextColor,
      children: labelText
    }), Icon && /*#__PURE__*/_jsx("span", {
      className: styles['icon'],
      children: /*#__PURE__*/_jsx(Icon, {
        color: "current_color"
      })
    }), /*#__PURE__*/_jsx("span", {
      className: styles['text'],
      children: text
    }), rightItem && /*#__PURE__*/_jsxs("div", {
      className: styles['right-item'],
      children: [rightItem === 'counter' && !!counter && /*#__PURE__*/_jsx("div", {
        className: clsx(styles['counter-container'], _defineProperty({}, styles['counter-container--accent'], !labelText && counterType === 'accent')),
        children: /*#__PURE__*/_jsx(Counter, {
          counter: counter,
          counterMaxLength: counterMaxLength,
          className: styles['counter']
        })
      }), rightItem === 'badge' && badged && !labelText && /*#__PURE__*/_jsx("div", {
        className: styles['badge']
      })]
    })]
  });
};